import { render, staticRenderFns } from "./RiskScoreWidget.vue?vue&type=template&id=131d157a&scoped=true"
import script from "./RiskScoreWidget.vue?vue&type=script&lang=js"
export * from "./RiskScoreWidget.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreWidget.vue?vue&type=style&index=0&id=131d157a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d157a",
  null
  
)

export default component.exports